<!--
 * @Author: your name
 * @Date: 2021-08-12 09:31:52
 * @LastEditTime: 2021-11-22 15:22:53
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \kr-health-manage\src\views\prescription\PrescriptionDetails\sport\rest\index.vue
-->
<template>
  <div class="noSportPlan">
    <img src="@/assets/img/no-sport.png" alt="" />
    <span>暂无处方</span>
  </div>
</template>

<script>
export default {};
</script>

<style lang="less" scoped>
.noSportPlan {
  display: flex;
  flex-direction: column;
  align-items: center;
  img {
    width: 1.5rem;
    height: 1.5rem;
    margin: 0.1rem 0;
  }
  span {
    width: 3rem;
    height: 0.7rem;
    line-height: 0.7rem;
    border-radius: 0.1rem;
  font-size: 0.25rem;
      color: #9abbed;
    text-align: center;
  }
}
</style>
